import { lazy } from 'react';

export const ActiveNft = lazy(() => import('./ActiveNFT.component'));
